import {AuthLayout} from './AuthLayout'
import {BannerBgd} from './BannerBgd'

export const imageNameMap = {
  AuthLayout,
  BannerBgd,
} as const
